import { useEffect, useMemo, useState } from "react";
import { useFuseSearch } from "@elixir/utils";
import { Appointment, BusinessAppointmentConfigs, TAptField, TAptFieldOption } from "@elixir/types";
import SelectionDropdown from "../apt-fields/selection-dropdown";
import { QUEUE_CONFIG_KEY } from "../../../../constants/config";
import usePushAptFieldToAptV2 from "../../../../apis/tryst/use-push-apt-field-to-apt-v2";

const LabelsDropdown = ({
  apt,
  // fieldItem,
}: {
  apt: Appointment;
  // fieldItem: TAptField;
}) => {
  const { fieldMeta, title } = { title: "Labels", fieldMeta: { type: "option", subType: "single" } };

  const [options, setOptions] = useState<TAptFieldOption[]>([]);
  
  useEffect(() => {
    const { labels = [{
      "hex": "#D75C86",
      "bg_hex": "#F2DEE5",
      "archive": true,
      "label_id": 2,
      "label": "2ND OPINION"
  }] } = JSON.parse(
      localStorage.getItem(QUEUE_CONFIG_KEY) || "{}"
    ) as BusinessAppointmentConfigs;
    setOptions(labels.map((label) => ({
      id: label.label_id,
      value: label.label,
      description: "",
      color: label.hex,
      bgColor: label.bg_hex,
      isSelected: apt.label === label.label_id,
    })))
  }, [apt.label]);

  const { mutate: pushAptFieldToApt } = usePushAptFieldToAptV2();
  const [searchQuery, setSearchQuery] = useState<string>("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const filteredOptions =
    useFuseSearch(searchQuery, options || [], ["value"]) || [];

  const searchOptions = useMemo(() => {
    if (searchQuery && searchQuery.length > 0) {
      return filteredOptions;
    }
    return options || [];
  }, [filteredOptions, options, searchQuery]);

  const handleOptionSelect = (optionsToPush?: TAptFieldOption[]) => {
    pushAptFieldToApt({
      appointment: apt,
      field: "label",
      value: optionsToPush?.[0]?.id,
    });
  };

  console.log("optionsoptionsoptions", {options, apt});

  return (
    <SelectionDropdown
      searchQuery={searchQuery}
      onSearch={setSearchQuery}
      dropdownOptions={options || []}
      filteredOptions={searchOptions}
      type={fieldMeta.subType as "single" | "multi"}
      title={title}
      onOptionSelect={handleOptionSelect}
    />
  );
};

export default LabelsDropdown;
